import { useQuery } from '@tanstack/react-query';
import { fetchExplanation, type ExplainQuery } from '../api/insights';
import { aiQueryKeys } from './query-keys';

const TEN_MIN_MS = 10 * 60 * 1000;

export const useExplainEntity = (p: ExplainQuery & { enabled: boolean }) =>
  useQuery({
    queryKey: aiQueryKeys.explain({ pluginId: p.pluginId, entityType: p.entityType, entityId: p.entityId, field: p.field }),
    queryFn: () => fetchExplanation({ pluginId: p.pluginId, entityType: p.entityType, entityId: p.entityId, field: p.field }),
    enabled: p.enabled,
    staleTime: TEN_MIN_MS,
  });
